<template>
  <!-- 右侧边栏 -->
  <div class="rightSidebar" @click="rightclick()">
    <div class="rightSidebar_content">
      <div>
        <img
          @click.stop="chooseCheak()"
          v-show="!this.task_status"
          src="../../assets/img/home/center/uncomplete.png"
          alt=""
          class="min_img"
        />
        <img
          v-show="this.task_status"
          src="../../assets/img/home/center/complete.png"
          alt=""
          class="min_img"
        />
      </div>
      <div id="mftext" contenteditable="true" @blur="modifytext">
        {{ detailsinpt }}
      </div>
    </div>
    <div class="rightSidebar_list">
      <div class="rightSidebar_center">
        <div class="center_setup">
          <input type="text" style="width: 0; height: 0; border: 0" />
          <div class="classification" @click.stop="classificationf">
            <img src="../../assets/img/rightsideber/familylist.png" alt="" />
            <p>{{ fackname }}</p>
          </div>
          <div class="radio_overfl" :class="dispno ? 'disbl' : ''">
            <template>
              <el-radio-group
                v-model="radio"
                class="radio_lisi"
                @change="classificationXz()"
              >
                <el-radio
                  class="radio_lisi_item"
                  :label="item.from_id"
                  v-for="(item, index) in famlitem"
                  :key="index"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
            </template>
          </div>
          <ul>
            <li>
              <img src="../../assets/img/rightsideber/adddate.png" alt="" />
              <div class="newlybuild_time">
                <p v-if="!value1">添加日期</p>
                <p v-if="value1">{{ value1 }}</p>
                <el-date-picker
                  v-model="value1"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :change="choiceTime()"
                >
                </el-date-picker>
              </div>
            </li>
            <li style="position: relative">
              <img src="../../assets/img/rightsideber/repeat.png" alt="" />
              <p v-show="repeatnumb == 1" @click.stop="repeatclick">设置重复</p>
              <p v-show="repeatnumb != 1" @click.stop="repeatclick">
                {{ repeatitem[repeatnumb - 1] }}
              </p>
              <div class="radio_overfl" :class="cfdispno ? 'disbl' : ''">
                <template>
                  <el-radio-group
                    v-model="repeatnumb"
                    class="radio_lisi"
                    @change="repeatxz()"
                  >
                    <el-radio
                      class="radio_lisi_item"
                      :label="index + 1"
                      v-for="(item, index) in repeatitem"
                      :key="index"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </template>
                <div
                  class="deletesp"
                  @click="repeatnumb = 1"
                  v-show="repeatnumb != 1"
                >
                  <img src="../../assets/img/home/center/deleter.png" alt="" />
                  <span @click="dleetcf()">删除重复</span>
                </div>
              </div>
            </li>
            <li style="position: relative">
              <img src="../../assets/img/rightsideber/setquadrant.png" alt="" />
              <p v-show="fournumb == 4" @click.stop="fourclick">设置象限</p>
              <p v-show="fournumb != 4" @click.stop="fourclick">
                {{ fourtitem[fournumb - 1] }}
              </p>
              <div class="radio_overfl" :class="fourdisp ? 'disbl' : ''">
                <template>
                  <el-radio-group
                    v-model="fournumb"
                    class="radio_lisi"
                    @change="fourxz()"
                  >
                    <el-radio
                      class="radio_lisi_item"
                      :label="index + 1"
                      v-for="(item, index) in fourtitem"
                      :key="index"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </template>
                <div
                  class="deletesp"
                  @click="fournumb = 4"
                  v-show="fournumb != 4"
                >
                  <img src="../../assets/img/home/center/deleter.png" alt="" />
                  <p @click="deletxx()">删除象限</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="add_notes">
          <img src="../../assets/img/rightsideber/addnotes.png" alt="" />
          <textarea
            name=""
            id=""
            placeholder="添加备注"
            class="newlybuild_describe"
            v-model="textareaipt"
            @blur="bluript()"
          ></textarea>
        </div>
      </div>
      <div class="rightSidebar_bottom">
        <img
          src="../../assets/img/rightsideber/return.png"
          alt=""
          @click="todorigClick()"
        />
        <span>
          {{ uptiem.split("T")[0] }}&nbsp;&nbsp;{{
            uptiem.split("T")[1]
          }}&nbsp;&nbsp;创建</span
        >
        <img
          src="../../assets/img/rightsideber/delete.png"
          alt=""
          @click="deleteTodo()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import bus from "./../../util/bus";
export default {
  data() {
    return {
      textareaipt: "",
      radio: 0,
      dispno: false,
      famlitem: [],
      detailsdata: "",
      detailsinpt: "",
      fackname: "",
      task_status: "",
      value1: "",
      //控制重复按钮
      cfdispno: false,
      repeatnumb: 1,
      repeatitem: ["无", "每天", "每周工作日", "每周", "每月", "每年"],
      //控制选择四象限按钮
      fourdisp: false,
      fournumb: 4,
      fourtitem: ["重要紧急", "重要不紧急", "不重要紧急", "不重要不紧急"],
      uptiem: "",
    };
  },
  props: {
    detatodo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mounted() {
    console.log(this.detatodo, "右边的值");

    this.detailsdata = this.detatodo;
    this.detailsinpt = this.detailsdata.task_name;
    //备注
    this.textareaipt = this.detailsdata.task_desc;
    //创建时间
    this.uptiem = this.detailsdata.create_time.split(".")[0];
    // 选择时间
    this.value1 = this.detailsdata.task_time;

    console.log(this.value1 == false, "999999999999");
    //重复
    this.repeatnumb = this.detailsdata.task_repeat + 1;
    //象限
    this.fournumb = this.detailsdata.type + 1;
    this.task_status = this.detailsdata.task_status;
    //分类
    if (this.detatodo.todo_from == null) {
      this.radio = 0;
    } else {
      this.radio = this.detatodo.todo_from;
      for (var i = 0; i < this.famlitem.length; i++) {
        if (this.radio == this.famlitem[i].from_id)
          this.fackname = this.famlitem[i].name;
      }
      console.log(this.radio, "分类");
    }
  },
  watch: {
    detatodo(val) {
      console.log(val, "右边的值");
      this.detailsdata = val;
      this.detailsinpt = this.detailsdata.task_name;
      //备注
      this.textareaipt = this.detailsdata.task_desc;
      //创建时间
      this.uptiem = this.detailsdata.create_time.split(".")[0];
      // 选择时间
      this.value1 = this.detailsdata.task_time;
      //重复
      this.repeatnumb = this.detailsdata.task_repeat + 1;
      //象限
      this.fournumb = this.detailsdata.type + 1;
      this.task_status = this.detailsdata.task_status;
      //分类
      if (this.detatodo.todo_from == null) {
        this.radio = 0;
      } else {
        this.radio = this.detatodo.todo_from;
        for (var i = 0; i < this.famlitem.length; i++) {
          if (this.radio == this.famlitem[i].from_id)
            this.fackname = this.famlitem[i].name;
        }
        console.log(this.radio, "分类");
      }
    },
  },
  created() {
    this.queryEntry();
    console.log(this.detatodo, "右边的值");
  },
  methods: {
    //修改清单内容
    modifytext() {
      var text = document.getElementById("mftext").textContent;
      console.log(text, "ooooooooooooo");
      console.log(this.detailsinpt, "ooooooooooooo");
      console.log(this.detailsinpt != text, "kkkkkkk");
      if (this.detailsinpt != text) {
        let data = {
          task_name: text,
        };
        this.modifyTodo(data);
      }
    },
    queryEntry() {
      console.log(this.dispno);
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .navnumbar("", header)
        .then((res) => {
          this.famlitem = res.data.result[1].todo_data;
          let aa = {
            from_id: 0,
            name: "未分类",
          };
          this.famlitem.unshift(aa);

          for (var i = 0; i < this.famlitem.length; i++) {
            if (this.radio == this.famlitem[i].from_id)
              this.fackname = this.famlitem[i].name;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    todorigClick() {
      this.$emit("todorigClick");
    },
    classificationf() {
      this.dispno = !this.dispno;
    },
    //设置分类
    classificationXz() {
      for (var i = 0; i < this.famlitem.length; i++) {
        if (this.radio == this.famlitem[i].from_id)
          this.fackname = this.famlitem[i].name;
      }
      // console.log('分类')
      if (this.radio != this.detatodo.todo_from) {
        console.log("选择了分类", this.radio);
        let data = {
          task_time: this.value1,
          todo_from: this.radio,
        };
        this.modifyTodo(data);
      }
    },
    //点击已完成
    chooseCheak() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      let data = {
        todo_id: this.detailsdata.id,
      };
      this.$api
        .completed(data, header)
        .then((res) => {
          this.$emit("refreshData");
          this.task_status = true;
          console.log(res, "点击已完成");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //设置重复
    repeatclick() {
      this.cfdispno = !this.cfdispno;
      this.dispno = false;
    },
    //选择象限按钮
    fourclick() {
      this.fourdisp = !this.fourdisp;
      this.cfdispno = false;
      this.dispno = false;
    },
    //改变了时间
    choiceTime() {
      if (this.value1 != "" && this.value1 != this.detailsdata.task_time) {
        let data = {
          task_time: this.value1,
        };
        this.modifyTodo(data);
      }
    },
    //删除重复
    dleetcf() {
      let data = {
        task_time: this.value1,
        task_repeat: 0,
      };
      this.modifyTodo(data);
    },
    //改变了重复
    repeatxz() {
      if (this.detailsdata != "") {
        if (this.detailsdata.task_repeat + 1 != this.repeatnumb) {
          let data = {
            task_time: this.value1,
            task_repeat: this.repeatnumb - 1,
          };
          this.modifyTodo(data);
        }
      }
    },
    //删除象限
    deletxx() {
      let data = {
        task_time: this.value1,
        type: 3,
      };
      this.modifyTodo(data);
    },
    //改变了象限
    fourxz() {
      if (this.detailsdata != "") {
        if (this.detailsdata.type + 1 != this.fournumb) {
          let data = {
            task_time: this.value1,
            type: this.fournumb - 1,
          };
          console.log("改变象限");
          this.modifyTodo(data);
        }
      }
    },
    bluript() {
      if (this.detailsdata != "") {
        if (this.textareaipt != this.detailsdata.task_desc) {
          let data = {
            task_desc: this.textareaipt,
            task_time: this.value1,
          };
          console.log("改变了备注");
          this.modifyTodo(data);
        }
      }
    },
    //修改接口
    modifyTodo(data) {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      this.$api
        .modifytodo(this.detailsdata.id, data, header)
        .then((res) => {
          console.log(res, "修改清单");
          this.$emit("refreshData");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //删除清单
    deleteTodo() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .deletetodo(this.detailsdata.id, header)
        .then((res) => {
          console.log(res, "删除清单");
          //刷新左侧边栏
          bus.$emit("refreshLeft");
          this.$emit("refreshData");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 监听全页面的点击事件
    rightclick() {
      this.dispno = false;
      this.cfdispno = false;
      this.fourdisp = false;
    },
  },
};
</script>

<style lang="scss">
.rightSidebar {
  min-width: 286px;
  height: 100%;
  background-color: #fff;
  padding-left: 4px;
  display: flex;
  flex-direction: column;

  .rightSidebar_list {
    font-size: 15px;
    color: #666;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .rightSidebar_center {
      width: 100%;
      flex: 1;
      background-color: #f2f4f8;
      padding: 4%;
      .center_setup {
        position: relative;
        background-color: #fff;
        padding: 0 18px;
        border-radius: 8px;
        img {
          width: 15px;
          height: 15px;
          margin-right: 18px;
        }

        .classification {
          padding: 18px 0 10px 0;
          display: flex;
          align-items: center;
        }
        .disbl {
          display: block !important;
        }
        .deletesp {
          display: flex;
          width: 100%;
          align-items: center;
          padding-left: 30px;
          color: #dc282b;
          img {
            width: 15px;
            height: 15px;
            margin: 0 8px 0 0;
          }
        }
        .radio_overfl {
          display: none;
          position: absolute;
          top: 40px;
          left: 50px;
          width: 180px;
          height: auto;
          max-height: 280px;
          overflow-y: auto;
          background-color: #fff;
          z-index: 50;
          box-shadow: 0px 4px 32px 3px rgba(0, 0, 0, 0.19);
          .radio_lisi {
            display: flex;
            flex-direction: column;
            .el-radio {
              padding: 0;
              margin-left: 30px;
            }
            .radio_lisi_item {
              text-align: left;
              line-height: 35px;
              font-size: 14px;
            }
          }
        }

        ul {
          li {
            display: flex;
            align-items: center;
            font-size: 15px;
            line-height: 46px;
            p {
              display: inline-block;
              height: 100%;
              width: 100%;
              border-bottom: 1px solid #dedede;
            }
          }
          li:last-child p {
            border: none;
          }
          .newlybuild_time {
            position: relative !important;
            width: 100%;
            .el-date-editor {
              width: auto !important;
              position: absolute !important;
              top: 0 !important;
              left: 0 !important;
              opacity: 0;
            }
          }
        }
      }
      .add_notes {
        display: flex;
        background-color: #fff;
        margin: 20px 0;
        height: 30%;
        padding: 18px;
        border-radius: 8px;
        img {
          width: 15px;
          height: 18px;
        }
        .newlybuild_describe {
          width: 100%;
          height: 100%;
          padding-left: 5px;
          resize: none;
          outline: none;
          border-style: none;
          font-size: 15px;
          font-family: SourceHanSansSC-Regular;
        }
      }
    }
    .rightSidebar_bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 3%;
      width: 100%;
      height: 50px;
      background-color: #fff;
      img {
        width: 10px;
        height: 18px;
      }
      :nth-child(3) {
        width: 18px;
        height: 18px;
      }
    }
  }
}
.rightSidebar_content {
  padding: 51px 4% 34px 4%;
  width: 100%;
  display: flex;
  > :nth-child(1) {
    img {
      width: 21px;
      height: 21px;
      margin-right: 20px;
    }
  }
  > :nth-child(2) {
    display: inline-block;
    height: auto;
    width: calc(100% - 50px);
    border: none;
  }
  [contenteditable]:focus {
    outline: none;
  }
}
</style>